import { useEffect, useId, useRef } from 'react';

export default function Modal({ titulo, onClose, children, largura = 560 }) {
  const dialogRef = useRef(null);
  const tituloId = useId();

  useEffect(() => {
    const anterior = document.activeElement;
    dialogRef.current?.focus();

    const aoTeclar = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', aoTeclar);
    return () => {
      document.removeEventListener('keydown', aoTeclar);
      anterior?.focus?.();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-3"
      style={{ background: 'rgba(19,26,36,.45)', zIndex: 1050 }}
      onClick={onClose}
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={tituloId}
        tabIndex={-1}
        className="card-soft"
        style={{ width: '100%', maxWidth: largura, maxHeight: '90vh', overflowY: 'auto', outline: 'none' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="card-soft__header">
          <h2 id={tituloId} className="card-soft__title" style={{ fontSize: 16 }}>
            {titulo}
          </h2>
          <button type="button" onClick={onClose} className="btn-close" aria-label="Fechar" style={{ fontSize: 12 }} />
        </div>
        <div className="card-soft__body">{children}</div>
      </div>
    </div>
  );
}
